document.addEventListener("DOMContentLoaded", function () {
  function attachHiddenInputs() {
    setTimeout(function () {
      // Retrieve the cookie ID and shop ID
      let cookieId = window.Wrz.Properties.cid;
      let shopId = window.Wrz.Properties.shop_id;
      let userId = window.Wrz.Properties.wrzuser.user_id;
      let wrzdiscount = window.Wrz.Properties.wrzuser.z_curr;

      // Select all forms with the specified action
      const forms = document.querySelectorAll('form[action="/cart/add"]');
      forms.forEach((form) => {
        // Skip if the hidden input fields already exist
        if (
          form.querySelector(`input[name="properties[_cookie_id]"]`) &&
          form.querySelector(`input[name="properties[_shop_id]"]`) &&
          form.querySelector(`input[name="properties[_prd_img]"]`) &&
          form.querySelector(`input[name="properties[_prd_url]"]`) &&
          form.querySelector(`input[name="properties[_user_id]"]`) &&
          form.querySelector(`input[name="properties[_wrz_discount]"]`)
        ) {
          return;
        }

        // Find parent element that contains the form
        let parentElement =
          form.closest(
            ".product-card, .product-item, .product-container , .grid__item ,.container .product"
          ) || form.parentElement;

        // Find image within the parent element
        let imageElement = parentElement
          ? parentElement.querySelector("img")
          : null;
        let imageUrl = imageElement ? imageElement.src : "";

        // Find link within the parent element
        let linkElement = parentElement
          ? parentElement.querySelector("a")
          : null;
        let productUrl = linkElement ? linkElement.href : "";

        // Function to create and append a hidden input
        function addHiddenInput(name, value) {
          if (!form.querySelector(`input[name="properties[_${name}]"]`)) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = `properties[${name}]`;
            input.value = value;
            form.appendChild(input);
          }
        }

        // Add hidden inputs to the form
        addHiddenInput("_cookie_id", cookieId);
        addHiddenInput("_shop_id", shopId);
        addHiddenInput("_prd_img", imageUrl);
        addHiddenInput("_prd_url", productUrl);
        addHiddenInput("_user_id", userId);
        addHiddenInput("_wrz_discount", wrzdiscount);
      });
    }, 3000);
  }

  attachHiddenInputs();

  // Set up MutationObserver to detect DOM changes
  const observer = new MutationObserver(() => {
    attachHiddenInputs();
  });

  // Configuration for MutationObserver
  const observerOptions = {
    childList: true,
    attributes: false,
    subtree: true,
  };

  observer.observe(document.body, observerOptions);
});

